
import {HTTP_HEADERS} from './httpHeaders';

export const ARROW_CONFIG = {
  httpHeaders: HTTP_HEADERS,
  events: {
    ui: {
      ajaxContentLoaded: 'UI:ajaxContentLoaded'
    }
  },
  framesPerSecondMs: {
    60: 16.6667,
    50: 20,
    30: 32,
    15: 64
  }
};



// WEBPACK FOOTER //
// ./uikit/config/index.js